export default function authHeader() {
  const userName = "assa-webclient";
  const password = "c62n1NWnV5";
  const auth = window.btoa(userName + ":" + password);

  return { Authorization: "Basic " + auth };
}
